export default __webpack_public_path__ + "static/media/Description.7172ffc2.jpeg";